var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIco7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_49984",
    "data-name": "Group 49984",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.684,
    height: 40,
    viewBox: "0 0 34.684 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138080",
    "data-name": "Rectangle 138080",
    width: 34.684,
    height: 40,
    fill: "#ee4758",
    stroke: "#ee4758",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48713",
    "data-name": "Group 48713",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_426",
    "data-name": "Ellipse 426",
    cx: 8.333,
    cy: 8.333,
    r: 8.333,
    transform: "translate(9.009 1.667)",
    fill: "#ee4758",
    stroke: "#ee4758",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93236",
    "data-name": "Path 93236",
    d: "M28.335,43H7.017a5.01,5.01,0,0,1-3.941-8.1,18.2,18.2,0,0,1,14.6-6.9,18.2,18.2,0,0,1,14.6,6.9A5.01,5.01,0,0,1,28.335,43Z",
    transform: "translate(-0.333 -4.667)",
    fill: "#ee4758",
    stroke: "#ee4758",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIco7);
export default __webpack_public_path__ + "static/media/user-ico7.f6247e2235201101d49e72dac6052893.svg";
export { ForwardRef as ReactComponent };